module.exports = __webpack_public_path__ + "img/img_bg1_lvshoucamp.9dbb3bed.png";